module.exports = __webpack_public_path__ + "img/pingtai.3990044e.png";